import { render, staticRenderFns } from "./LayoutPrivate.vue?vue&type=template&id=1110de45&"
import script from "./LayoutPrivate.vue?vue&type=script&lang=js&"
export * from "./LayoutPrivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports